import { useEffect, useState } from "react";

// localStorage-based (not a user-account field) since this is a one-off
// marketing nudge, not something that needs to sync across a customer's
// devices or survive them clearing site data. Dismissing it only stops the
// AUTOMATIC one-time popup — the footer/sidebar "Download on the App
// Store" link can still reopen it any time via `openDialog`.
const DISMISSED_KEY = "waypoint_ios_app_announcement_dismissed_v1";

export default function useIosAppAnnouncement({ autoShowOnMount = false } = {}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!autoShowOnMount) return;
    try {
      if (!localStorage.getItem(DISMISSED_KEY)) setOpen(true);
    } catch (_) {
      // localStorage unavailable (privacy mode, etc.) — skip the
      // automatic popup rather than risk showing it on every load with no
      // way to persist a dismissal.
    }
  }, [autoShowOnMount]);

  const openDialog = () => setOpen(true);

  const closeDialog = () => {
    setOpen(false);
    try {
      localStorage.setItem(DISMISSED_KEY, "1");
    } catch (_) {}
  };

  return { open, openDialog, closeDialog };
}
